import * as firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/functions';
import 'firebase/storage'
import { initFirestorter } from "firestorter";
import firebaseConfig from "shared/services/firebase/firebaseConfig";

firebase.initializeApp(firebaseConfig);
initFirestorter({ firebase: firebase as any });